import React from "react";
import styled from "styled-components";
import {Link} from "gatsby";

const StyledMenu = styled.nav`
  display: flex;
  flex-direction: column;
  // justify-content: center;
  background: #dfe4ec;
  z-index: 9;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
  height: 100vh;
  text-align: left;
  padding: 0;
  position: absolute;
  top: 70px;
  right: 0;
  transition: transform 0.8s ease-in-out;
  width: 80%;

  @media (max-width: 576px) {
    width: 100%;
  }

  a {
    font-size: 20px;
    padding: 15px 0 15px 20px;
    font-weight: bold;
    color: #063783;
    font-weight: 700;
    text-decoration: none;
    transition: color 0.3s linear;
    text-align: left !important;
    border-top: 1px solid rgba(6, 55, 131, .2);

    @media (max-width: 576px) {
      font-size: 1.5rem;
      text-align: center;
    }

    &:hover {
      color: #343078;
    }
  }
`;

const Menu = ({ open }) => {
	return (
		<StyledMenu open={open}>
			<Link to={'/'} className='menu-list-link' activeStyle={{ color: '#ec6842' }}>
				Home
			</Link>
			<Link to={'/car-finance'} className='menu-list-link' activeStyle={{ color: '#ec6842' }}>
				Car Finance Claims
			</Link>
			<Link to={'/faq'} className='menu-list-link' activeStyle={{ color: '#ec6842' }}>
				FAQ
			</Link>
			<Link to={'/news'} className='menu-list-link' activeStyle={{ color: '#ec6842' }}>
				News
			</Link>
			<Link to={'/contact'} className='menu-list-link' activeStyle={{ color: '#ec6842' }}>
				Contact
			</Link>
		</StyledMenu>
	);
};

export default Menu;
